import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import NewMessageHeader from './new_message_header/NewMessageHeader';
import NewMessageBox from './new_message_box/NewMessageBox';

{/* User avatar and markdown box to create new Client Messages   */}
const CorrespondanceNewMessage = (props) => {
  const {
    // props for NewMessageHeader
    corType,
    setCorType,
    sortDir,
    setSortDir,

    // props for NewMessageBox
    clientRn,
    clientBackend,
  } = props;
  return (
    <Stack
      sx={{
        py: 1,
        px: {md: 2, xs: 1},
      }}
    >
      <NewMessageHeader
        corType={corType}
        setCorType={setCorType}
        sortDir={sortDir}
        setSortDir={setSortDir}
      />
      <NewMessageBox
        clientRn={clientRn}
        clientBackend={clientBackend}
      />
    </Stack>
  );
};
CorrespondanceNewMessage.propTypes = {
  // props for NewMessageHeader
  corType: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
    LOGS: PropTypes.bool.isRequired,
    CALENDLY_UPDATE: PropTypes.bool.isRequired,
    DIALPAD_SMS_TEXT: PropTypes.bool.isRequired,
    DIALPAD_CALL_TRANSCRIPT: PropTypes.bool.isRequired,
  }).isRequired,
  setCorType: PropTypes.func.isRequired,
  sortDir: PropTypes.string.isRequired,
  setSortDir: PropTypes.func.isRequired,

  // props for NewMessageBox
  clientRn: PropTypes.string.isRequired,
  clientBackend: PropTypes.object.isRequired,
};

export default React.memo(CorrespondanceNewMessage);
